module.exports = __webpack_public_path__ + "757af94f8fcc610e3d132cad7ad81350-811_5_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_5_2x.png
// module id = 618
// module chunks = 0